import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStylesFacebook from './styles'

const Progress = () => {
    const classes = useStylesFacebook();

    return (
        <CircularProgress 
            color="secondary"
            className={classes.bottom}
            size={20}
        />
    );
}

export default Progress;
